export const state = {
  active: false,
  pageNumber: 1,
  apiConfig: null,
  existingInvoices: null,
  carriers: [],
  packages: [],
  total: 0,
};
